export default "__VITE_ASSET__BlUaUjuT__"